import request from '@/utils/request'
const BASE_URL = '/scratcheditor'

// 获取列表
export function getScratchUserRecordsList(params) {
    return request({
        url: BASE_URL + '/get_scratch_user_records_list',
        method: 'get',
        params
    })
}

// 删除
export function postDeleteScratchUserRecords(data) {
    return request({
        url: BASE_URL + '/delete_scratch_user_records',
        method: 'post',
        data
    })
}
